interface RequestTypeSource {
  type: string;
  requestedResolution?: string | null;
  items?: Array<{
    requestedResolution?: string | null;
    resolution?: string | null;
  }> | null;
}

export const getRequestTypeLabel = (request: RequestTypeSource): string => {
  if (request.type === 'ISSUE') return 'Issue';
  const requested = (request.items || []).map(item => item.requestedResolution).filter(Boolean);
  const resolutions = requested.length ? requested : request.requestedResolution
    ? [request.requestedResolution]
    : (request.items || []).map(item => item.resolution)
    .filter(Boolean);
  if (!resolutions.includes('EXCHANGE')) return 'Return';
  return resolutions.some(resolution => resolution !== 'EXCHANGE')
    ? 'Return & exchange'
    : 'Exchange';
};
